/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Combobox, OutlinedButton } from '@neo4j-ndl/react';
import { AdjustmentsHorizontalIconOutline } from '@neo4j-ndl/react/icons';

const Component = () => {
  const options = [
    { label: 'Neo4j', value: 'neo4j' },
    { label: 'Aura', value: 'aura' },
    { label: 'Bloom', value: 'bloom' },
  ];

  return (
    <Combobox
      // The custom trigger renders no label of its own, so the label reaches it
      // as its accessible name only.
      label="Product"
      options={options}
      searchPlaceholder="Search products"
      // The panel anchors to whichever element the props land on, and that
      // element becomes the combobox, so it has to be focusable.
      renderTrigger={({ ref, ...triggerProps }, state) => (
        <OutlinedButton
          ref={ref as React.Ref<HTMLButtonElement>}
          htmlAttributes={triggerProps}
          leadingVisual={<AdjustmentsHorizontalIconOutline />}
        >
          {state.selectedOptions[0]?.label ?? 'Pick a product'}
        </OutlinedButton>
      )}
    />
  );
};

export default Component;
